import loadable from '@loadable/component';

export const CmsSignUpBlockLoadable = loadable(
  () => import('./CmsSignUpBlock'),
  { resolveComponent: (module) => module.CmsSignUpBlock },
);
